var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatHabitacionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#2DBECD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3091 12.1586L14.0001 6.85714L5.69108 12.1586C5.42561 12.328 5.34876 12.6789 5.51941 12.9424C5.69007 13.2059 6.04362 13.2822 6.30909 13.1128L7.14299 12.5807V20.5757C7.14299 20.8889 7.39883 21.1429 7.71442 21.1429C7.76379 21.1429 7.81169 21.1366 7.85738 21.125C7.90299 21.1366 7.9508 21.1428 8.00006 21.1428H20.0001C20.0494 21.1428 20.0972 21.1366 20.1428 21.1249C20.1885 21.1366 20.2364 21.1429 20.2858 21.1429C20.6014 21.1429 20.8573 20.8889 20.8573 20.5757V12.5808L21.6911 13.1128C21.9566 13.2822 22.3101 13.2059 22.4808 12.9424C22.6514 12.6789 22.5746 12.328 22.3091 12.1586ZM19.7144 11.8516L14.0001 8.2056L8.28585 11.8515V20.0085H19.7144V11.8516ZM12.2858 13.77H15.7144V17.1729H12.2858V13.77ZM13.4287 14.9043V16.0386H14.5715V14.9043H13.4287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHabitacionalIcon);
export default __webpack_public_path__ + "static/media/chat-habitacional-icon.74fd361c.svg";
export { ForwardRef as ReactComponent };